import VIDEO_PLAYBACK_STATUSES from 'widget/constants/video-playback-status';

export const isVideoPlaying = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PLAYING;
export const isVideoPaused = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PAUSED;
export const isVideoPlayRequested = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PLAY_REQUESTED;
export const isVideoPauseRequested = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PAUSE_REQUESTED;

export const isVideoEnded = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.ENDED;

export const isVideoPlayingOptimistic = state => (isVideoPlaying(state) || isVideoPlayRequested(state));
export const isVideoPausedOptimistic = state => (isVideoPaused(state) || isVideoPauseRequested(state));




// WEBPACK FOOTER //
// ./src/widget/selectors/video-playback-status.js